if (window.location.pathname == '/job-ad-board/') {
	const switchContainer = document.querySelector('[data-view-switches]'),
		switchList = document.querySelector('[data-view-switch="list"]'),
		switchGrid = document.querySelector('[data-view-switch="grid"]'),
		sortingBtn = document.querySelector('[data-sorting-btn]'),
		sortingMenu = document.querySelector('[data-sorting-menu]'),
		sortOptions = sortingMenu.querySelectorAll('[role="menuitem"]'),
		featuredSort = document.querySelector('[data-sort-featured]'),
		dateSort = document.querySelector('[data-sort-date]'),
		loadMore = document.querySelector('#ajax-load-more'),
		sortALM = document.querySelector('.alm-filter--sort');

	// View switcher logic
	if (switchContainer) {
		switchList.addEventListener('click', () => {
			switchList.classList.add('active');
			switchGrid.classList.remove('active');
			loadMore.classList.remove('view-grid');

			switchList.setAttribute('aria-selected', 'true');
			switchGrid.setAttribute('aria-selected', 'false');

			switchList.setAttribute('aria-disabled', 'false');
			switchGrid.setAttribute('aria-disabled', 'true');
		});

		switchGrid.addEventListener('click', () => {
			switchGrid.classList.add('active');
			switchList.classList.remove('active');
			loadMore.classList.add('view-grid');

			switchGrid.setAttribute('aria-selected', 'true');
			switchList.setAttribute('aria-selected', 'false');

			switchGrid.setAttribute('aria-disabled', 'false');
			switchList.setAttribute('aria-disabled', 'true');
		});
	}

	sortingBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		const isExpanded = sortingBtn.getAttribute('aria-expanded') === 'true';
		sortingBtn.setAttribute('aria-expanded', !isExpanded);
		sortingMenu.classList.toggle('active');
	});

	sortOptions.forEach((option) => {
		option.addEventListener('click', () => selectOption(option));
		option.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				selectOption(option);
			}
		});
	});

	function selectOption(option) {
		sortingMenu.classList.remove('active');
		sortingBtn.setAttribute('aria-expanded', 'false');
		sortingBtn.focus();

		let selectedSort;
		if (option.hasAttribute('data-sort-featured')) {
			selectedSort = 'ASC:featured_job';
		} else if (option.hasAttribute('data-sort-date')) {
			selectedSort = 'DESC:date';
		}

		const newUrl = new URL(window.location);
		newUrl.searchParams.set('sort', selectedSort);
		window.history.replaceState({}, '', newUrl);

		sortOptions.forEach((opt) => {
			opt.classList.remove('active');
			opt.setAttribute('aria-selected', 'false');
		});
		option.classList.add('active');
		option.setAttribute('aria-selected', 'true');

		setTimeout(() => {
			document
				.querySelector(
					`[aria-labelledby="alm-filter-sort-title"] [data-value="${selectedSort}"]`
				)
				.click();
		}, 0);
	}

	document.addEventListener('click', (e) => {
		if (!sortingBtn.contains(e.target) && !sortingMenu.contains(e.target)) {
			closeDropdown();
		}
	});

	sortingMenu.addEventListener('focusout', (e) => {
		if (
			!sortingMenu.contains(e.relatedTarget) &&
			!sortingBtn.contains(e.relatedTarget)
		) {
			closeDropdown();
		}
	});

	sortingBtn.addEventListener('focusout', () => {
		setTimeout(() => {
			if (
				!sortingMenu.contains(document.activeElement) &&
				!sortingBtn.contains(document.activeElement)
			) {
				closeDropdown();
			}
		}, 10);
	});

	function closeDropdown() {
		sortingMenu.classList.remove('active');
		sortingBtn.setAttribute('aria-expanded', 'false');
	}

	// Prevent dropdown from closing when clicking inside
	sortingMenu.addEventListener('click', (e) => e.stopPropagation());

	// Keyboard navigation for sorting button
	sortingBtn.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			sortingBtn.click();
		} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
			e.preventDefault();
			openDropdown();
			sortOptions[0].focus();
		} else if (e.key === 'Escape') {
			closeDropdown();
		}
	});

	function openDropdown() {
		sortingMenu.classList.add('active');
		sortingBtn.setAttribute('aria-expanded', 'true');
	}

	// Set correct active sort option on page load based on URL
	document.addEventListener('DOMContentLoaded', function () {
		const urlParams = new URLSearchParams(window.location.search);
		const sortParam = urlParams.get('sort');

		if (sortParam === 'ASC:featured_job' && featuredSort) {
			selectOption(featuredSort);
		} else if (sortParam === 'DESC:date' && dateSort) {
			selectOption(dateSort);
		}

		function disableTabOnDisabledPagination() {
			setTimeout(() => {
				document.querySelectorAll('.alm-paging a').forEach((link) => {
					link.setAttribute('tabindex', '0');
					link.removeAttribute('role');
				});

				document.querySelector('.alm-paging').setAttribute('role', 'list');

				document
					.querySelectorAll('.alm-paging li.disabled a')
					.forEach((link) => {
						link.setAttribute('tabindex', '-1');
						link.removeAttribute('role');
					});
			}, 300);
		}

		setTimeout(function () {
			updatePaginationAccessibility();
			disableTabOnDisabledPagination();
		}, 1500);

		document.addEventListener('click', function (event) {
			if (event.target.closest('.alm-paging a')) {
				setTimeout(disableTabOnDisabledPagination, 300);
			}
		});

		function updatePaginationAccessibility() {
			const paginationContainer = document.querySelector('.alm-paging');
			if (!paginationContainer) return;

			const urlParams = new URLSearchParams(window.location.search);
			const currentPage = parseInt(urlParams.get('pg')) || 1;
			const paginationItems = paginationContainer.querySelectorAll('li.num');
			const prevLink = paginationContainer.querySelector('li.prev a');
			const nextLink = paginationContainer.querySelector('li.next a');

			// Add ARIA roles to pagination
			paginationContainer.setAttribute('role', 'navigation');
			paginationContainer.setAttribute(
				'aria-label',
				'Pagination Navigation'
			);

			// Update page numbers for screen readers
			paginationItems.forEach((item) => {
				const link = item.querySelector('a');
				const pageNumber = parseInt(link.dataset.page);
				if (pageNumber === currentPage) {
					link.setAttribute('aria-current', 'page');
					link.setAttribute(
						'aria-label',
						`Current Page, Page ${pageNumber}`
					);
				} else {
					link.setAttribute('aria-label', `Go to Page ${pageNumber}`);
				}
			});

			// Update Previous button label
			if (prevLink) {
				prevLink.setAttribute('aria-label', 'Previous Page');
			}

			// Update Next button label
			if (nextLink) {
				nextLink.setAttribute('aria-label', 'Next Page');
			}
		}

		function updatePageUrl(pageNumber) {
			const newUrl = new URL(window.location);
			newUrl.searchParams.set('pg', pageNumber);
			return newUrl.toString();
		}
	});
}
